
import searchBar from '@/components/SearchBar';
import anList from './component/anList';
import { getItavMaterialList } from '@/api/res_store/list';

export default {
  components: {
    searchBar: searchBar,
    anList: anList
  },

  data: function data() {
    return {
      aList: [],
      bListLoading: true,
      nPage: 1,
      nPageSize: 15,
      nTotal: 1,
      oSearchData: {},
      aSearchProp: {
        customSelector: [{
          selectorId: 'tag1_id',
          name: '动作',
          tagId: 2,
          multiple: true
        }],
        searchField: true,
        keyword: true,
        defaultKey: 'name',
        aSearchField: [{
          id: 'name',
          name: '按动作名称'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.fnRenderList();
  },


  watch: {
    $route: function $route(to, from) {
      if (to.name === '动作库') {
        this.bListLoading = true;
        var self = this;
        setTimeout(function () {
          self.bListLoading = false;
        }, 3000);
      }
    }
  },

  methods: {
    fnRenderList: function fnRenderList(data) {
      var oTemp = {};
      var self = this;
      if (data) {
        self.oSearchData = data;
        self.nPage = 1;
      }
      oTemp = self.oSearchData;
      oTemp.page = self.nPage;
      oTemp.res_type = 2;
      self.bListLoading = true;
      getItavMaterialList(oTemp).then(function (res) {
        self.bListLoading = false;
        self.aList = res.data.data.list;
        self.nTotal = res.data.data.total;
      });
    },
    fnCurrentChange: function fnCurrentChange(val) {
      this.nPage = val;
      this.fnRenderList();
    }
  }
};